import * as React from "react";
import { Spin } from "antd";
import { EditForm } from "./EditForm";
import { CustomModal } from "../common/CustomModal";

export class EditModal extends React.Component {
  render() {
    const { visible, onClose, languageSelectedData, onSubmit } = this.props;

    return (
      <CustomModal
        width="1000px"
        visible={visible}
        title="Edit Language"
        onClose={onClose}
      >
        <EditForm 
          data={languageSelectedData} 
          onSubmit={onSubmit} 
          handleCancel={onClose}
        />
      </CustomModal>
    );
  }
}
